export const GET_ROOMS = "CHAT@GET_ROOMS";
export const GET_ROOMS_INIT = "CHAT@GET_ROOMS_INIT";
export const GET_ROOMS_SUCCESS = "CHAT@GET_ROOMS_SUCCESS";
export const GET_ROOMS_FAILED = "CHAT@GET_ROOMS_FAILED";

export const UPLOAD_FILES = "CHAT@UPLOAD_FILES";
export const UPLOAD_FILES_INIT = "CHAT@UPLOAD_FILES_INIT";
export const UPLOAD_FILES_SUCCESS = "CHAT@UPLOAD_FILES_SUCCESS";
export const UPLOAD_FILES_FAILED = "CHAT@UPLOAD_FILES_FAILED";

export const GET_MESSAGES = "CHAT@GET_MESSAGES";
export const GET_MESSAGES_INIT = "CHAT@GET_MESSAGES_INIT";
export const GET_MESSAGES_SUCCESS = "CHAT@GET_MESSAGES_SUCCESS";
export const GET_MESSAGES_FAILED = "CHAT@GET_MESSAGES_FAILED";

export const EMPTY_MESSAGES = "CHAT@EMPTY_MESSAGES";

export const REMOVE_MESSAGES = "CHAT@REMOVE_MESSAGES";
export const ADD_SINGLE_MESSAGES = "CHAT@ADD_SINGLE_MESSAGES";

export const ACTIVE_ROOM_UPDATE = "CHAT@ACTIVE_ROOM_UPDATE";

export const UPDATE_ARCHIVE = "CHAT@UPDATE_ARCHIVE";
export const UPDATE_ARCHIVE_INIT = "CHAT@UPDATE_ARCHIVE_INIT";
export const UPDATE_ARCHIVE_SUCCESS = "CHAT@UPDATE_ARCHIVE_SUCCESS";
export const UPDATE_ARCHIVE_FAILED = "CHAT@UPDATE_ARCHIVE_FAILED";

export const GET_ARCHIVE = "CHAT@GET_ARCHIVE";
export const GET_ARCHIVE_INIT = "CHAT@GET_ARCHIVE_INIT";
export const GET_ARCHIVE_SUCCESS = "CHAT@GET_ARCHIVE_SUCCESS";
export const GET_ARCHIVE_FAILED = "CHAT@GET_ARCHIVE_FAILED";

export const SEEN_MESSAGES = "HEDGEFUND@SEEN_MESSAGES";
export const SEEN_MESSAGES_INIT = "HEDGEFUND@SEEN_MESSAGES_INIT";
export const SEEN_MESSAGES_SUCCESS = "HEDGEFUND@SEEN_MESSAGES_SUCCESS";
export const SEEN_MESSAGES_FAILED = "HEDGEFUND@SEEN_MESSAGES_FAILED";
